import { setToken, clearToken } from "@/lib/api";

const FLAG = "operamind_impersonating";

// Enter a customer's dashboard as Super Admin. The customer app reads
// `operamind_token`; the admin session lives under `operamind_admin_token`
// (untouched), so exiting simply returns to the admin portal.
export const startImpersonation = (token, editMode) => {
  setToken(token);
  localStorage.setItem(FLAG, editMode ? "edit" : "view");
  window.location.href = "/dashboard";
};

export const isImpersonating = () => Boolean(localStorage.getItem(FLAG));

export const exitImpersonation = () => {
  clearToken();
  localStorage.removeItem(FLAG);
  window.location.href = "/admin/customers";
};
